<template>
  <div class="header animate__animated animate__backInLeft">
    <div class="common header-box clearfix">
      <div class="header-left" @click="handleTo('/', 0)">
        <img src="../assets/img/logo.png" alt />
      </div>
      <div class="header-right">
        <ul class="header-right-ul">
          <li
            class="header-right-ul-li"
            :class="isActive == 0 ? 'active' : ''"
            @click="handleTo('/', 0)"
          >
            首页
          </li>
          <li class="header-right-ul-li" :class="isActive == 1 ? 'active' : ''">
            <span @click="handleTo('/service', 1)">亚太服务</span>
            <div class="ol-box">
              <ol>
                <li class="ol-li" @click="handleTo('/service', 1, 0)">
                  <a>集成系统服务</a>
                </li>
                <li
                  class="ol-li"
                  @click="handleTo('/service', 1, 1)"
                  style="text-align: left !important; margin-left: 20px"
                >
                  <a>运维服务</a>
                </li>
                <li class="ol-li" @click="handleTo('/service', 1, 2)">
                  <a>电子认证服务</a>
                </li>
                <img src="../assets/img/sjx.png" alt />
              </ol>
            </div>
          </li>
          <li class="header-right-ul-li" :class="isActive == 2 ? 'active' : ''">
            <span @click="handleTo('/product', 2)">亚太产品</span>
            <div class="ol-box" style="width: 250px">
              <ol style="width: 250px; padding-left: 0px">
                <li class="ol-li" @click="handleTo('/product', 2, 0)">
                  <a>信息系统集成软件产品</a>
                </li>
                <li
                  class="ol-li"
                  style="text-align: left !important; margin-left: 26px"
                >
                  <a href="https://www.ezca.org/" target="_blank"
                    >电子认证服务产品</a
                  >
                </li>
                <li
                  class="ol-li"
                  @click="handleTo('/product', 2, 2)"
                  style="text-align: left !important; margin-left: 26px"
                >
                  <a>代理产品</a>
                </li>
                <img src="../assets/img/sjx.png" alt />
              </ol>
            </div>
          </li>
          <li class="header-right-ul-li" :class="isActive == 3 ? 'active' : ''">
            <span @click="handleTo('/about', 3)">关于亚太</span>
            <div class="ol-box" style="width: 140px">
              <ol style="width: 140px">
                <li class="ol-li active" @click="handleTo('/about', 3, 0)">
                  <a href="#">企业简介</a>
                </li>
                <li class="ol-li" @click="handleTo('/about', 3, 1)">
                  <a href="#">新闻公告</a>
                </li>
                <li class="ol-li" @click="handleTo('/about', 3, 2)">
                  <a href="#">企业文化</a>
                </li>
                <li class="ol-li" @click="handleTo('/about', 3, 3)">
                  <a href="#">资质荣誉</a>
                </li>
                <img src="../assets/img/sjx.png" alt />
              </ol>
            </div>
          </li>
          <li
            class="header-right-ul-li"
            :class="isActive == 4 ? 'active' : ''"
            @click="handleTo('/connect', 4)"
          >
            联系我们
          </li>
        </ul>
      </div>
      <div class="btn-link">
        <span class="animate__animated animate__jello">友情链接</span>
        <div class="ol-box" style="text-align: left">
          <ol>
            <li class="btn-link-ol-li">
              <a href="http://www.zhongxungroup.com/" target="_blank"
                >重庆中讯控股（集团）有限公司</a
              >
            </li>
            <li class="btn-link-ol-li">
              <a href="https://www.ezca.org/" target="_blank"
                >东方中讯数字证书认证有限公司</a
              >
            </li>
            <li class="btn-link-ol-li">
              <a href="http://www.zhongxunjintonggroup.com/" target="_blank"
                >重庆中讯金通投资（集团）有限公司</a
              >
            </li>
            <li class="btn-link-ol-li" style="border-bottom: none">
              <a href="http://www.cqzydc.cn/" target="_blank"
                >重庆中誉地产开发有限公司</a
              >
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "Header",
  data() {
    return {
      isActive: 0,
      aboutActive: 0,
    };
  },
  methods: {
    handleTo(path, type, activeNo = 0) {
      this.$router.push({
        path,
        query: {
          activeNo,
          isActive: 1,
        },
      });

      this.isActive = type;
    },
    changeActive(value) {
      this.isActive = value;
    },
  },
  watch: {
    $route: function (to, from) {
      console.log(to.path);
      if (to.path == "/service") {
        this.changeActive(1);
      }
      if (to.path == "/") {
        this.changeActive(0);
      }
      if (to.path == "/product") {
        this.changeActive(2);
      }
      if (to.path == "/about") {
        this.changeActive(3);
      }
      if (to.path == "/connect") {
        this.changeActive(4);
      }
    },
  },
  created() {},
  mounted() {
    if (this.$router.history.current.fullPath.indexOf("/service") > -1) {
      this.changeActive(1);
    }
    if (this.$router.history.current.fullPath.indexOf("/") > -1) {
      this.changeActive(0);
    }
    if (this.$router.history.current.fullPath.indexOf("/product") > -1) {
      this.changeActive(2);
    }
    if (this.$router.history.current.fullPath.indexOf("/about") > -1) {
      this.changeActive(3);
    }
    if (this.$router.history.current.fullPath.indexOf("/connect") > -1) {
      this.changeActive(4);
    }
  },
  updated() {
    // console.log(this.$router.history.current.fullPath.indexOf("/service") > -1);
  },
};
</script>

<style scoped>
.btn-link-ol-li {
  border-bottom: 2px solid #ccc;
  font-size: 16px;
  line-height: 40px;
  font-weight: 600;
  margin: 0 20px;
}
.btn-link .ol-box {
  width: 300px;
  padding: 20px 0;
  position: absolute;
  top: 50px;
  left: 0px !important;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 2px 2px 10px #eee;
}
.btn-link {
  width: 120px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 18px;
  background: #a1251e;
  position: absolute;
  border-radius: 60px;
  top: 36px;
  right: 130px;
}
.header {
  position: fixed;
  z-index: 100;
  background-color: #fff;
  margin: auto;
  width: 100%;
}
.header-box {
  min-height: 134px;
  position: relative;
  font-weight: 600;
}
.header-left {
  float: left;
  width: 365px;
  cursor: pointer;
  padding: 0 50px;
}
.header-left img {
  width: 266px;
  height: 100%;
  margin-top: 25px;
}
a {
  color: #000 !important;
}
.header-right {
  float: left;
  margin-left: 50px;
  position: relative;
}
.header-right-ul {
  min-height: 130px;
  line-height: 130px;
  box-sizing: border-box;
}
.header-right-ul .header-right-ul-li {
  float: left;
  line-height: 130px;
  width: 160px;
  font-size: 20px;
  box-sizing: border-box;
  position: relative;
}
.header-right-ul .header-right-ul-li:hover {
  color: #5694f5;
  border-bottom: 4px solid #5694f5;
  cursor: pointer;
}
.header-right-ul .header-right-ul-li.active {
  color: #5694f5;
  border-bottom: 4px solid #5694f5;
}
.ol-box {
  padding-top: 20px;
  position: absolute;
  width: 164px;
  min-height: 200px;
  top: 120px;
  left: 0px;
  display: none;
  z-index: 10;
}
.btn-link:hover .ol-box {
  display: block;
  cursor: pointer;
}
.header-right-ul-li:hover .ol-box {
  display: block;
  cursor: pointer;
}
.header-right-ul-li .ol-box ol {
  width: 164px;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  z-index: 10;
}
.ol-li {
  width: 100%;
  font-size: 20px;
  line-height: 68px;
  font-weight: 500;
}
.header-right-ul-li .ol-box ol img {
  position: absolute;
  width: 18px;
  height: 10px;
  top: -10px;
  left: 40px;
}
.ol-li:hover a {
  color: #5694f5 !important;
}
@media screen and (max-width: 1500px) {
  .header-left {
    width: 25%;
    padding: 0 10px;
  }
  .header-right-ul .header-right-ul-li {
    width: 100px;
    font-size: 20px;
    line-height: 100px;
    box-sizing: border-box;
    position: relative;
  }
  .header {
    height: 104px;
  }
  .ol-box {
    padding-top: 0px;
    position: absolute;
    width: 164px;
    min-height: 200px;
    top: 110px;
    left: 0px;
    display: none;
    z-index: 10;
  }
  .btn-link {
    right: 90px;
  }
}

@media screen and (max-width: 1080px) {
  .common {
    width: 1080px !important;
  }
  .header {
    width: 1080px;
  }
  .header-right {
    margin-left: 0px;
  }
  .header-box {
    height: 100px !important;
  }
  .header-right-ul .header-right-ul-li {
    width: 100px;
    font-size: 20px;
    line-height: 100px;
    box-sizing: border-box;
    position: relative;
  }
  .btn-link {
    top: 26px;
    right: 80px;
  }
  .header-right-ul {
    min-height: 100px;
    line-height: 100px;
    box-sizing: border-box;
  }
  .header-left img {
    width: 180px;
    height: 100px;
    margin-top: 0px;
  }
}
</style>